
<v-app :style="`background: ${theme.background}`">
  <v-main>
    <router-view :key="$route.fullPath" />
  </v-main>
</v-app>
